import clsx from "clsx";
import { UploadInputProps } from "./UploadInput.types";
import useUploadInput from "./hook/useUploadInput";
import renderUploadInputChildren from "./util/renderUploadInputChildren";
import { UploadInputRoot } from "./UploadInput.styles";

function UploadInput({
    isLoading = false,
    readonly,
    disabled,
    onChange,
    upload,
    onError,
    onSuccess,
    onUploadStart,
    onUploadEnd,
    onFileUploaded,
    children,
    className,
    ...rest
}: UploadInputProps) {
    /**
     * Hook to upload files to server and mange upload status
     */
    const { handleFileChange, fileUri, ...status } = useUploadInput({
        isLoading,
        readonly,
        disabled,
        onChange,
        upload,
        onError,
        onSuccess,
        onUploadStart,
        onUploadEnd,
        onFileUploaded,
    });

    return (
        <UploadInputRoot
            onChange={handleFileChange}
            className={clsx("upload-input", status, className)}
            readonly={readonly}
            disabled={disabled}
            {...rest}
        >
            {(drag) => (
                <>
                    {renderUploadInputChildren(children, {
                        ...status,
                        drag,
                        fileUri,
                    })}
                </>
            )}
        </UploadInputRoot>
    );
}

export default UploadInput;
